import * as React from 'react';

import { SVG } from '@longline/aqua-ui/svg';
import { IMapButtonProps, MapButton } from '@longline/aqua-ui/map/controls/base/MapButton';

import { useGlobalState } from '../contexts/state/GlobalStateContext';

const EyedropperButton = (props: IMapButtonProps) => {
  const globalState = useGlobalState();
  const isActive = globalState.mode === 'eyedropper';

  const handleClick = (e?: React.MouseEvent | React.KeyboardEvent) => {
    e?.stopPropagation();
    if (isActive) {
      globalState.setMode(null);
    } else {
      globalState.setMode('eyedropper');
    }
  };

  return (
    <MapButton
      onClick={handleClick}
      hint="Inspect layer values"
      active={isActive}
      {...props}
    >
      <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <use xlinkHref={SVG.Icons.Eyedropper}></use>
      </svg>
    </MapButton>
  );
}

export { EyedropperButton }
